/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchDestinationPathParams = NonNullable<operations['patchDestination']['parameters']['path']>;

export type PatchDestinationRequestBody = OperationRequestBodyContent<operations['patchDestination']>;

export interface Input extends PatchDestinationPathParams {
  apiVersion?: string;
  body: PatchDestinationRequestBody;
}

export async function patchDestination(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/destinations/{projectKey}/{environmentKey}/{id}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
